<template>
  <v-container v-if="$auth.check()">

  </v-container>
</template>

<script>
export default {
  name: 'UserNotification',
};
</script>
